// A claudeProxy hibakódjainak felhasználói szövege — A3 (külső audit,
// 2026-10-14). A szerver a hibát kódként adja (`{ error: "<kód>" }`), az
// upstream (Anthropic) részletei nem jutnak ki; itt csak a tegeződő,
// érthető üzenet születik.

/** A beviteli mező felső határa — UGYANAZ, mint a szerver MAX_USER_CHARS-a
 * (functions/src/proxyGuards.ts). A kliens nem importálhat a functions/
 * csomagból; az egyezést a chatErrors.test.ts drift-őre védi. */
export const MAX_CHAT_INPUT_CHARS = 2000;

const MESSAGES: Record<string, string> = {
  daily_limit_reached: "Elérted a napi üzenetlimitet. Holnap folytathatjuk! 😊",
  message_too_long: `Ez az üzenet túl hosszú. Kérlek, fogalmazd meg röviden (legfeljebb ${MAX_CHAT_INPUT_CHARS} karakter).`,
  email_not_verified: "Az asszisztens használatához előbb erősítsd meg az e-mail-címedet.",
  busy: "Most sokan kérdeznek egyszerre — kérlek, próbáld újra pár perc múlva.",
};

const FALLBACK = "Hiba történt. Kérlek próbáld újra.";

export function chatErrorMessage(code: string | undefined): string {
  return (code && MESSAGES[code]) || FALLBACK;
}
